import { render } from "./SoftKeyBord.vue?vue&type=template&id=6074cdd4&scoped=true"
import script from "./SoftKeyBord.vue?vue&type=script&lang=js"
export * from "./SoftKeyBord.vue?vue&type=script&lang=js"

import "./SoftKeyBord.vue?vue&type=style&index=0&id=6074cdd4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6074cdd4"]])

export default __exports__